import {
  ImagePackPublishRequest,
  ImagePackResponse,
  ImagePacksResponse,
} from "@/types/image-packs"

import { baseApi } from "./base-api"

// Internal image packs playground: every pack with its revisions, publishing
// packs built by scripts/image-packs/build-pack.ts, and curating what's served.
export const imagePacksApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getImagePacks: builder.query<ImagePacksResponse, void>({
      query: () => ({ url: "/api/image_packs" }),
      providesTags: ["ImagePacks"],
    }),
    // One pack folder: pack.json, its sprites in manifest order, and the
    // sheet they were cut from, as base64 JSON (Cloudflare's WAF blocks
    // binary multipart uploads outside its upload allowlist).
    publishImagePack: builder.mutation<
      ImagePackResponse,
      ImagePackPublishRequest
    >({
      query: (data) => ({
        url: "/api/image_packs/publish",
        method: "POST",
        data,
      }),
      invalidatesTags: ["ImagePacks"],
    }),
    approveImagePackRevision: builder.mutation<ImagePackResponse, string>({
      query: (ref) => ({
        url: `/api/image_packs/revisions/${ref}/approve`,
        method: "POST",
      }),
      invalidatesTags: ["ImagePacks"],
    }),
    updateImagePackRevision: builder.mutation<
      ImagePackResponse,
      { ref: string; rejectedSprites: number[] }
    >({
      query: ({ ref, rejectedSprites }) => ({
        url: `/api/image_packs/revisions/${ref}`,
        method: "PATCH",
        data: { rejected_sprites: rejectedSprites },
      }),
      invalidatesTags: ["ImagePacks"],
    }),
    updateImagePack: builder.mutation<
      ImagePackResponse,
      { ref: string; retired: boolean }
    >({
      query: ({ ref, retired }) => ({
        url: `/api/image_packs/${ref}`,
        method: "PATCH",
        data: { retired },
      }),
      invalidatesTags: ["ImagePacks"],
    }),
  }),
})

export const {
  useGetImagePacksQuery,
  usePublishImagePackMutation,
  useApproveImagePackRevisionMutation,
  useUpdateImagePackRevisionMutation,
  useUpdateImagePackMutation,
} = imagePacksApi
